import _get from "lodash/get";
import { pxToRem } from '../../../../utils';
var headerStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var colors = v.colorScheme[p.color];
    return {
      display: 'block',
      color: _get(colors, 'foreground', v.color),
      fontSize: pxToRem(22),
      fontWeight: 400
    };
  }
};
export default headerStyles;
//# sourceMappingURL=headerDescriptionStyles.js.map
